import { PaymentUtilService } from './../../services/payment-util/payment-util.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-utm-wallet-hundred',
  templateUrl: './utm-wallet-hundred.component.html',
  styleUrls: ['./utm-wallet-hundred.component.scss']
})
export class UtmWalletHundredComponent implements OnInit {
  @Input() donation;
  @Input() type;

  constructor(
    public paymentUtilService: PaymentUtilService
  ) { }

  ngOnInit(): void {
  }

}
